module.exports = __webpack_public_path__ + "static/img/a5.45a679b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/a5.png
// module id = hZbv
// module chunks = 1